import React, { useEffect, useState } from 'react';
import { omit } from 'lodash';
import { Button } from 'antd';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import {
  getLoading,
  getTotal,
  getSearch,
  getSorting,
  getValidateFileLoading,
  getProcessImportLoading,
  getProcessStatus,
  getDeleteFileLoading,
  getUploadResponse,
  getDataValidated,
  getDataProcessed,
} from './import-reducer';
import { setSearchImport, fetchImportDetails, updateProcessImportResponse } from './import-actions';
import { UploadModal } from '../header/import/UploadModal';
import SearchImport from '../header/search/SearchImports';
import BaseGrid from '../grid/BaseGrid';
import { ResponseModal } from './ResponseModal';
import { importFileFailed, cleanImportLayout } from '../header/header-actions';
import { getErrors, getValid } from '../header/header-reducer';
import { ImportFileValidationModal } from './ImportFileValidationModal';
import { getWriteMenuPermissions } from '../../store/user/user-reducer';

export const ImportPage = () => {
  const dispatch = useDispatch();
  const search = useSelector(getSearch);
  const sorting = useSelector(getSorting);
  const total = useSelector(getTotal);
  const loading = useSelector(getLoading);
  const [openUpload, setOpenUpload] = useState(false);
  const validateFileLoading = useSelector(getValidateFileLoading);
  const processImportLoading = useSelector(getProcessImportLoading);
  const processStatus = useSelector(getProcessStatus);
  const deleteStatus = useSelector(getDeleteFileLoading);
  const [showResponse, setShowResponse] = useState(false);
  const errors = useSelector(getErrors);
  const valid = useSelector(getValid);
  const dataValidated = useSelector(getDataValidated);
  const dataProcessed = useSelector(getDataProcessed);
  const isEditAllowed = useSelector(getWriteMenuPermissions).import;

  let uploadResponse = useSelector(getUploadResponse);
  const searchPayload = {
    page: 0,
    size: 15,
  };
  useEffect(() => {
    if (valid === true || dataValidated === true || dataProcessed === true) {
      dispatch(cleanImportLayout());
      dispatch(fetchImportDetails(search));
      setOpenUpload(false);
    }
  }, [valid, search, dataValidated, dataProcessed]);

  useEffect(() => {
    dispatch(fetchImportDetails(search));
  }, [search]);

  useEffect(() => {
    if (errors?.length) {
      setOpenUpload(false);
    }
  }, [errors]);

  useEffect(() => {
    if (uploadResponse) setShowResponse(true);
    else setShowResponse(false);
  }, [uploadResponse]);

  const onPageChange = (pageData) => {
    dispatch(setSearchImport(pageData));
  };

  const uploadCancel = () => {
    setOpenUpload(false);
  };

  const onOk = () => {
    dispatch(updateProcessImportResponse(null));
    dispatch(fetchImportDetails(searchPayload));
    dispatch(importFileFailed(null));
  };

  return (
    <>
      <SearchImport />
      <Button
        type='primary'
        onClick={() => {
          setOpenUpload(true);
        }}
        disabled={!isEditAllowed}
      >
        Upload file
      </Button>
      <BaseGrid
        id={'import'}
        total={total}
        search={search}
        setSearch={onPageChange}
        loading={loading || validateFileLoading || processImportLoading || deleteStatus}
      />
      <UploadModal visible={openUpload} data={null} onCancel={uploadCancel} type={'Import File'} />
      <ImportFileValidationModal visible={!!errors?.length} data={errors} />
    </>
  );
};
